import { render, staticRenderFns } from "./TopCongreso.vue?vue&type=template&id=db57220a&"
import script from "./TopCongreso.vue?vue&type=script&lang=js&"
export * from "./TopCongreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports